import { render, staticRenderFns } from "./ProductSpecificationTab.vue?vue&type=template&id=ccdc2052&"
import script from "./ProductSpecificationTab.vue?vue&type=script&lang=ts&"
export * from "./ProductSpecificationTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports